/**
 * GENERATED by scripts/gen-staff-get-routes.js — do not edit by hand. Re-run it after a GET route is added, removed or
 * re-gated in teamio-serverless-api (cypress/node-tests/staff-get-routes.test.js fails until you do).
 *
 * The API's GET routes whose requestAuth policy includes siteMember / siteAdmin / superAdmin. Only these GETs carry the
 * signed-in user's login token (src/utils/authHeaderPolicy.js): a header on a cross-origin GET costs one CORS preflight,
 * so every other GET (public, oauth, health, not yet wrapped) goes out exactly as it does today.
 * `{name}` is one path segment.
 */
export const STAFF_GET_ROUTES = [
  "billing-portal",
  "campaign-ab-tests",
  "campaign-ab-tests/{abTestId}",
  "campaign-insurance-options",
  "campaign-list-members",
  "campaign-patient-zip-codes",
  "campaign-recall-types",
  "campaign-saved-lists",
  "campaign-site-lists",
  "campaign-statistics",
  "campaign-statistics/{campaignId}",
  "campaign-templates",
  "campaign-templates/{templateId}",
  "campaigns",
  "campaigns/sms-usage",
  "campaigns/{campaignId}",
  "campaigns/{campaignId}/clicks",
  "campaigns/{campaignId}/recipients",
  "email-reports/aggregate",
  "email-reports/config",
  "email-reports/logs",
  "email-settings/authenticated-domains",
  "email-settings/verification-status",
  "email-settings/verified-senders",
  "get-moolah-config",
  "get-moolah-devices",
  "get-od-api-config",
  "moolah-payment-info/{paymentID}",
  "moolah-transaction-status",
  "od-payment-definitions",
  "od-sync-status-list",
  "payment-config",
  "slack/channels",
  "slack/install",
  "slack/status",
  "stripe/account-status",
  "stripe/oauth/start",
  "text-to-pay-settings",
  "video/signed-url",
  "wa-onboarding/approved-messages",
  "wa-onboarding/my-status",
  "wa-onboarding/my-templates",
  "wa-onboarding/status"
];
